import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import { connect } from 'react-redux';

import { showNotification } from 'Store/Notification/Notification.action';
import { MixType } from 'Type/Common.type';
import { OrderType } from 'Type/Order.type';
import { isSignedIn } from 'Util/Auth';

import MyAccountOrderFavoriteButton from './MyAccountOrderFavoriteButton.component';

export const OrderDispatcher = import(
    /* webpackMode: "lazy", webpackChunkName: "dispatchers" */
    'Store/Order/Order.dispatcher'
);

/** @namespace PeggysagePwa/Component/MyAccountOrderFavoriteButton/Container/mapStateToProps */
export const mapStateToProps = (state) => ({
    isAddingOrderToFavorites: state.OrderReducer.isAddingOrderToFavorites
});

/** @namespace PeggysagePwa/Component/MyAccountOrderFavoriteButton/Container/mapDispatchToProps */
export const mapDispatchToProps = (dispatch) => ({
    addOrderToFavorites: (incrementId) => OrderDispatcher.then(
        ({ default: dispatcher }) => dispatcher.addOrderToFavorites(dispatch, incrementId)
    ),
    removeOrderFromFavorites: (incrementId) => OrderDispatcher.then(
        ({ default: dispatcher }) => dispatcher.removeOrderFromFavorites(dispatch, incrementId)
    ),
    showNotification: (type, message) => dispatch(showNotification(type, message))
});

/** @namespace PeggysagePwa/Component/MyAccountOrderFavoriteButton/Container */
export class MyAccountOrderFavoriteButtonContainer extends PureComponent {
    static propTypes = {
        order: OrderType.isRequired,
        onRemovedFromFavorites: PropTypes.func,
        isAddingOrderToFavorites: PropTypes.bool.isRequired,
        addOrderToFavorites: PropTypes.func.isRequired,
        removeOrderFromFavorites: PropTypes.func.isRequired,
        showNotification: PropTypes.func.isRequired,
        mix: MixType
    };

    static defaultProps = {
        onRemovedFromFavorites: null,
        mix: {}
    };

    state = {
        isFavoriteButtonLoading: false,
        isFavoriteToggle: false,
        isFavorite: false // prevent reloading order to change icon state
    };

    containerFunctions = {
        onButtonClick: this.onButtonClick.bind(this)
    };

    componentDidMount() {
        this.setFavoriteState();
    }

    componentDidUpdate(prevProps) {
        const {
            isAddingOrderToFavorites: isPrevAddingOrderToFavorites,
            order: { is_favorite: isPrevFavorite }
        } = prevProps;
        const {
            isAddingOrderToFavorites,
            order: { is_favorite: isFavorite }
        } = this.props;

        if (isPrevAddingOrderToFavorites && !isAddingOrderToFavorites) {
            this.setFavoriteButtonLoading(false);
        }

        if (isPrevFavorite !== isFavorite) {
            this.setFavoriteState();
        }
    }

    containerProps() {
        const { order, mix } = this.props;
        const { isFavorite } = this.state;

        return {
            mix,
            order,
            isDisabled: this.isDisabled(),
            // isFavorite: this.isFavorite(),
            isFavorite,
            isSignedIn: isSignedIn()
        };
    }

    /**
     * Set favorite state from order data
     */
    setFavoriteState() {
        const { order: { is_favorite = false } = {} } = this.props;

        this.setState({ isFavorite: !!is_favorite });
    }

    setFavoriteButtonLoading(isLoading) {
        return this.setState({ isFavoriteButtonLoading: isLoading });
    }

    async toggleOrderToFavorites(add = true) {
        const {
            order: { increment_id },
            addOrderToFavorites,
            removeOrderFromFavorites,
            onRemovedFromFavorites
        } = this.props;

        const {
            isFavoriteToggle,
            isFavorite
        } = this.state;

        if (isFavoriteToggle) {
            return;
        }

        this.setFavoriteButtonLoading(true);

        this.setState({ isFavoriteToggle: true });

        if (add) {
            // Add to favorites
            try {
                await addOrderToFavorites(increment_id);

                this.setState({ isFavorite: true });
            } finally {
                this.setState({ isFavoriteToggle: false });
            }

            return;
        }

        if (!isFavorite) {
            return; // already unfaved, no need to query
        }

        // Remove from favorites
        try {
            await removeOrderFromFavorites(increment_id);

            this.setState({ isFavorite: false });

            if (onRemovedFromFavorites) {
                onRemovedFromFavorites();
            }
        } finally {
            this.setState({ isFavoriteToggle: false });
        }
    }

    isDisabled() {
        const { isAddingOrderToFavorites } = this.props;
        return isAddingOrderToFavorites || !isSignedIn();
    }

    isFavorite() {
        const { order: { is_favorite = false } = {} } = this.props;

        return !!is_favorite;
    }

    onButtonClick(e) {
        // const { order: { is_favorite: isFavorite = false } = {} } = this.props;
        const { isFavorite } = this.state;

        e.preventDefault();
        e.stopPropagation();

        if (!isFavorite) {
            return this.toggleOrderToFavorites(true);
        }

        return this.toggleOrderToFavorites(false);
    }

    render() {
        const { isFavoriteButtonLoading } = this.state;

        return (
            <MyAccountOrderFavoriteButton
              isLoading={ isFavoriteButtonLoading }
              { ...this.containerFunctions }
              { ...this.containerProps() }
            />
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(MyAccountOrderFavoriteButtonContainer);
